//cardInfoPopup
(function() {
    var b2bBenefitItemList = '<li class="lists">'+
    '<div class="list-inner">' +
        '<div>'+ // CSR-4856 [개발][WA][모니터링]1차 심사결과_사업자몰_전시 : tabindex 삭제 : 117
        	'<a href="/benefits/exhibitions/detail-{{planEventId}}?b2bYn=Y" data-ec-promotion="{{ecPromotion}}">' +
            '<div class="thumb">' +
                '<img src="{{planEventListThumbnailPath}}{{planEventListThumbnailName}}" alt="{{planEventListThumbnailAltText}}">' +
            '</div>' +
            '<div class="info">' +
                '{{#if eventType}}' +
                '<div class="badge-container">' +
                    '<ul class="badge-list">' +
                    '{{#each eventTypeItem in eventTypeName.split(",")}}' +
                        '<li class="badge-item">{{eventTypeItem}}</li>' +
                    '{{/each}}' +
                    '</ul>' +
                '</div>' +
                '{{/if}}' +
                '<div class="tit">'+
                    '<span class="blind">이벤트 제목</span>{{planEventTitle}}'+
                '</div>'+
                '<p class="date"><span class="blind">이벤트 기간</span>{{planEventFromDate}}~{{planEventToDate}}</p>' +
            '</div>' +
          '</a>' +
        '</div>'+   // tabindex
    '</div>'+  // .list-inner
'</li>';	
	
    var B2B_MENU_STATE_SESSION_KEY = 'b2bExhibitionListFilter';   // 필터 활성화 상태 저장할 세션 키
    var b2bExhibitFirstList = [];
	var b2bDomains = "";
	var clickedCategory = [];
	var clickedEventType = [];
	var eventFilter = [];
    var b2bExhibitList = [];
    var b2bExhibitionList = { 
        init: function() {
            var self = this;
            lgkorUI.requestAjaxData("/evt/ajax/business/benefits/exhibitions", null, function(result) {
                if (result.status == "success") {
                    b2bExhibitList = result.data;
                }
                self.afterLoad();
            });
        },
        afterLoad: function(){
            var self = this;
            self.setting();
            self.bindEvents();
            vcui.require(['ui/carousel', 'libs/swiper-bundle-12.2.0.min'], function () {
                self.initHeroSwiper();
                self.initChoiseFilter();
                self.restoreFilterState();
                self.quickFilterInitBtn();
            });
            // 최초 1회 로드
            self.requestData();
        },
        el:{
            $section: null,
            $heroSwiper: null,
            $choiseFilterSwiper: null,
        },
        setting: function() {
            var self = this;
            // init setting시에 b2bExhibitList에 최초 조회된 리스트를 넣어놓고 계속 사용한다.
            b2bDomains = b2bDomain;
            eventFilter = JSON.parse(eventListJSON);
            if(b2bExhibitList != null){
            	var codeArr = [];
            	var nameArr = [];
            	$.each(eventFilter , function(idx , ef){
            		codeArr.push(ef.commonCodeId);
            		nameArr.push(ef.commonCodeName); 
            	});
            	b2bExhibitFirstList = b2bExhibitList;
            	$.each(b2bExhibitFirstList , function(idx , bRow){
        			var eventTypeName = "";            		
            		if(bRow.eventType != null){
            			if(bRow.eventType != null && bRow.eventType != ""){
            				$.each(bRow.eventType.split(",") , function(idx , bes){
	            				if(idx == 0){
	            					eventTypeName = nameArr[codeArr.indexOf(bes)];
	            				}else{
	            					eventTypeName += "," + nameArr[codeArr.indexOf(bes)];
	            				}
	            			});
            			}
            		}
       				bRow.eventTypeName = eventTypeName;
            	});
        	}
            self.el.$section = $('.event-membership');
            self.el.$heroSwiper = self.el.$section.find('.new-hero-banner');
            self.el.$choiseFilterSwiper = self.el.$section.find('.choice-filter-wrap');
        },

        bindEvents: function() {
            var self = this;
            //BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십 > 1뎁스 탭에 따라 탭컨텐츠 타이틀 변경
			var $tabDepth1 = $('.evt-main-tab-wrap .tabs-wrap-new.flexible-tab.ui_stickyTab');
			$(window).on('eventStickyTabchange',function(){
				var $tabContent = $('.evt-main-tab-wrap').next();
				if( $tabContent.hasClass('tab-contents')){
					$('.blind.content_title').remove();
					var contentTitle = $tabDepth1.find('li.on>a').text().replace('선택됨','');
					contentTitle = '<span class="blind content_title">'+contentTitle+' 카테고리 내용 시작</span>';
					$tabContent.prepend(contentTitle);
				}
			}).on('load',function(){
				$(window).trigger('eventStickyTabchange');
			})
		    $tabDepth1.on('stickyTabchange',function(e,_obj){
				$(window).trigger('eventStickyTabchange');
		    });

            $(document).on('click', '.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button', function() {
                var $this = $(this);
                var hasOn = $this.hasClass('on');

                if (!hasOn) {
                    $this.addClass('on');
                    $this.append('<span class="blind">선택</span><span class="close"><span class="blind">선택 해제</span></span>');
                } else {
                    $this.removeClass('on');
                    $this.find('.blind').remove();
                    $this.find('.close').remove();
                }

                self.quickFilterInitBtn();

                if ($this.closest('.choice-filter-wrap')[0].swiper) {
                    $this.closest('.choice-filter-wrap')[0].swiper.slideTo($this.closest('li').index() || 0, 0);
                }
            });

            $(document).on('click', '.evt-afilter-inner .item-reset button', function(e) {
                var $target = $(this);
                var $filterBtn = $target.closest('.evt-afilter-inner').find('li.swiper-slide button');

                $filterBtn.removeClass('on');
                $filterBtn.find('.blind').remove();
                $filterBtn.find('.close').remove();

                self.quickFilterInitBtn();
            });

            $('.tabs-wrap-new').on('stickyTabchange', function() {
                self.setFilterStorage();
            });

            $(document).on('click', '#categoryTab li', function() {
                self.requestData();
            });

            $(document).on('click', '#filterTab li', function() {
                self.requestData();
            });

            $(document).on('click', '.item-reset', function() {
                self.requestData();
            });
        },

        initHeroSwiper: function() {
            var self = this;
            self.el.$heroSwiper.each(function() {
                var $this = $(this);

                $this.vcCarousel({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    infinite: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    touchThreshold: 100,
                    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
                    speed: 300,
                }).on("carouselafterchange", function (e, slide, prev, next) {
                    setHeroBanner();
                })
            });

    
            function setHeroBanner(isFirst) {
                var heroList = self.el.$heroSwiper.find(".slide-track > li");
                var heroListAct = heroList.siblings(".ui_carousel_current").index();
                var heroListLength = heroList.length;
                var custom = self.el.$heroSwiper.find(".custom-indi-wrap");
                var slideCurrent = custom.find(".slide-page .current");
                var slideCount = custom.find(".slide-page .count");

                if (heroListLength > 1) {
                    custom.show();
                    custom.css("display", "flex");
                    slideCurrent.html('<span class="blind">현재 페이지</span>' + heroListAct);
                    slideCount.html('<span class="blind">총 페이지 수</span>' + (heroListLength - 2));
                } else {
                    custom.hide();
                }
            }
            setHeroBanner();
        },        
        
        initChoiseFilter: function() {
            if(!vcui.detect.isMobile){
                var self = this;
                self.el.$choiseFilterSwiper.each(function() {
                    var $this = $(this);
                    if(!$this.find('.swiper-slide').length) return;
                    $this.addClass('swiper-ally-custom');

                    if ($this.hasClass('swiper-initialized')) {
                        this.swiper.update();
                    } else {
                        $this[0].swiper = new Swiper(this, {
                            freeMode: true,
                            slidesPerView: 'auto',
                            resistance: true,
                            resistanceRatio: 0,
                            observer: true,
                            observeParents: true,
                            spaceBetween: 4,
                            breakpoints: {
                                767: {
                                    spaceBetween: 8,
                                },
                            },
                            // slideToClickedSlide: true,
                            a11y: false
                        });
                    }
                });
            }
        },

        quickFilterInitBtn: function() {
            var self = this;
            var $resetBtn = $('.evt-afilter-inner .item-reset');

            if ($('.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button.on').length > 0) {
                $resetBtn.show();
            } else {
                $resetBtn.hide();
            }
            $('.evt-main-tab-wrap .choice-filter-wrap').each(function() {
                if (this.swiper) {
                    this.swiper.update();
                }
            });
            self.setFilterStorage();
        },

        setFilterStorage: function() {
            var self = this;
            var tabIndex = self.el.$section.find('.tabs-wrap-new .on').index();
            var act1 = $.map(self.el.$section.find('.evt-main-tab-wrap .choice-filter-wrap .swiper-slide button.on'), function(el){return $(el).closest('li').index()});

            sessionStorage.setItem(B2B_MENU_STATE_SESSION_KEY, JSON.stringify({
                tabIndex: tabIndex,
                act1: act1
            }));
        },

        restoreFilterState: function() {
            var self = this;
            var stateData = sessionStorage.getItem(B2B_MENU_STATE_SESSION_KEY) ? JSON.parse(sessionStorage.getItem(B2B_MENU_STATE_SESSION_KEY)) : null;
            var navi = performance.getEntriesByType("navigation")[0];

            if (navi && navi.type === 'back_forward' && stateData) {
                var tabIndex = stateData.tabIndex;
                var act1 = stateData.act1;

                self.el.$section.find('.tabs-wrap-new').each(function() {
                    var $this = $(this);
                    if ($this.vcStickyTab) {
                        $this.vcStickyTab('select', tabIndex, true);
                    }
                    if ($this.vcSmoothScroll) {
                        $this.vcSmoothScroll('scrollToActive', 0);
                    }
                });

                act1.forEach(function(val) {
                    var $target = self.el.$choiseFilterSwiper.find('.swiper-slide:eq('+ val +') button');
                    if (!$target.hasClass('on')) {
                        $target.addClass('on');
                        $target.append('<span class="blind">선택</span><span class="close"><span class="blind">선택 해제</span></span>');
                    }
                });

				self.quickFilterInitBtn(); // Update the filter button state
				self.requestData();
            } else {
                sessionStorage.removeItem(B2B_MENU_STATE_SESSION_KEY);
            }
        },

        requestData: function() {
        	var self = this;
        	var filteredList = [];
        	
            var categoryId = getActiveCategoryId();
            var eventType = getActiveEventType();        	
            
            //매번 카테고리 refresh
            clickedCategory = [];
            if(categoryId != ""){
            	clickedCategory.push(categoryId);
            }
            // 매번 이벤트 refresh
            clickedEventType = [];
            if(eventType != ""){
            	clickedEventType = eventType;
            }
            
            // 둘다 풀려있으면 list는 원래 리스트로.
            if(clickedCategory.length == 0 && clickedEventType.length == 0){
            	filteredList = b2bExhibitFirstList;
            }else{
            	$.each(b2bExhibitFirstList , function(idx , row){
            		var categoryBool , eventBool = false;
            		if(clickedCategory.length == 0){
            			categoryBool = true;
            		}else{
            			if(row.bizType != undefined && row.bizType.indexOf(clickedCategory[0]) != -1) categoryBool = true;
            		}
            		if(clickedEventType.length == 0){
            			eventBool = true;
            		}else{ 
            			$.each(clickedEventType , function(iidx , evtType){
            				if(row.eventType.indexOf(evtType) != -1){
            					eventBool = true;
            					return false;
            				}            				
            			});
            		} 
            		
            		if(categoryBool && eventBool){
            			filteredList.push(row);
            		}            		
            	});
            } 
            
            function getActiveCategoryId(){
                var categoryId ='';
                $('#categoryTab li').each(function() {
                    if ($(this).hasClass('on')) {
                        categoryId = $(this).data('category-id');
                    }
                })
                return categoryId;
            }

            function getActiveEventType() {
                var activeEventType = [];
                $('#filterTab li').each(function() {
                    var filterId = $(this).data('filter-id');
                    var button = $(this).find('button');

                    if (button.hasClass('on')) {
                        activeEventType.push(filterId);
                    }
                });
                return activeEventType;
            }
            
        	self.updateList(filteredList);
        	
        },

        updateList: function(benefitList) { // Moved updateList here
            var $list = $('ul#benefitList');
            var $noData = $('div.no-data');


            $list.empty();
            if (benefitList.length > 0) {
                $noData.hide();
                $.each(benefitList, function(index, item) {
                    item.eventType = item.eventType ? item.eventType : "";
                    item.eventId = item.eventId ? item.eventId : null;

                    var ecPromotion = {
                        "promo_id": b2bDomains+"/benefits/exhibitions/detail-"+item.planEventId+"?b2bYn=Y",
                        "promo_name": item.planEventTitle,
                        "promo_creative": item.planEventListThumbnailPath + item.planEventListThumbnailName,
                        "promo_position": index
                    };
                    item.ecPromotion = JSON.stringify(ecPromotion);
                    $list.append(vcui.template(b2bBenefitItemList, item));
                });
            } else {
                $noData.show();
            }
        },
    }

    $(window).ready(function() {
    	b2bExhibitionList.init();
    });

})();
